<template>
  <div>
    <div v-if="noColumns">
      <Subtitle v-if="title" :title="title" :description="description" />
      <slot />
    </div>
    <v-row class="my-0" v-else>
      <v-col cols="5" class="my-2 pr-4">
        <Subtitle v-if="title" :title="title" :description="description" />
        <slot name="left" />
      </v-col>
      <v-col cols="7" class="my-2 pl-4 pt-0">
        <slot name="right" />
      </v-col>
    </v-row>
    <PhasesNavigateButtons
      :showNextButton="hasNextButton"
      :showBackButton="hasBackButton"
      @next="$emit('next')"
      @back="$emit('back')"
    />
  </div>
</template>

<script>
import Subtitle from './Subtitle'
import PhasesNavigateButtons from '../PhasesNavigateButtons'

export default {
  components: {
    Subtitle,
    PhasesNavigateButtons,
  },
  props: {
    title: {
      default: '',
      type: String,
    },
    description: {
      default: '',
      type: String,
    },
    tid: {
      default: 'phase-section',
      type: String,
    },
    hasNextButton: Boolean,
    hasBackButton: Boolean,
    noColumns: { type: Boolean, default: false },
  },
}
</script>
